export default __webpack_public_path__ + "static/media/card-success-light.3bd819c3.svg";